import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Logo } from '@/components/Logo';
import { API, setToken, setStoredUser } from '@/lib/api';

export default function AcceptInvitePage() {
    const { token } = useParams();
    const [info, setInfo] = useState(null);
    const [error, setError] = useState(null);
    const [full_name, setFullName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${API}/team/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(e?.response?.data?.detail || 'Invite not found'));
    }, [token]);

    const accept = async (e) => {
        e.preventDefault();
        if (!full_name || password.length < 8) {
            toast.error('Please enter your name and a password of at least 8 chars.');
            return;
        }
        setLoading(true);
        try {
            const r = await axios.post(`${API}/team/invite/accept`, { token, full_name, password });
            setToken(r.data.access_token);
            setStoredUser(r.data.user);
            toast.success('Welcome to the team!');
            navigate('/app/dashboard');
        } catch (err) {
            toast.error(err?.response?.data?.detail || 'Failed to accept invite');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <header className="bg-white border-b"><div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center"><Logo /></div></header>
            <div className="flex-1 flex items-center justify-center p-6">
                <Card className="w-full max-w-md">
                    <CardHeader>
                        <CardTitle className="font-display text-2xl">{info ? `Join ${info.org_name}` : (error || 'Loading…')}</CardTitle>
                    </CardHeader>
                    <CardContent>
                        {info && (
                            <form onSubmit={accept} className="space-y-3">
                                <div>
                                    <Label>Email</Label>
                                    <Input value={info.email} disabled />
                                </div>
                                <div>
                                    <Label htmlFor="name">Your name</Label>
                                    <Input id="name" value={full_name} onChange={(e) => setFullName(e.target.value)} data-testid="invite-name-input" required />
                                </div>
                                <div>
                                    <Label htmlFor="pw">Password (min 8 chars)</Label>
                                    <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="invite-password-input" required />
                                </div>
                                <Button type="submit" disabled={loading} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="invite-accept-button">
                                    {loading ? 'Joining…' : 'Accept invite'}
                                </Button>
                            </form>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
